import { render } from "./PlantNotifications.vue?vue&type=template&id=61133892"
import script from "./PlantNotifications.vue?vue&type=script&lang=js"
export * from "./PlantNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__